<template>
  <div class="home-page">
    <!-- 整屏头图 -->
    <section class="home-hero">
      <ElCarousel :interval="5000" height="calc(100vh - 0.8rem)">
        <ElCarouselItem v-for="(b, i) in bannerList" :key="i">
          <div class="home-hero-slide" :style="{ backgroundImage: `url(${b.imgUrl})` }">
            <div class="home-hero-overlay">
              <h1 class="home-hero-title">{{ b.title }}</h1>
              <p class="home-hero-desc">{{ b.des }}</p>
              <ElButton size="large" class="home-btn-black" v-if="b && b.type == 0" @click="handleHeroBuy(b)">立即购买</ElButton>
            </div>
          </div>
        </ElCarouselItem>
      </ElCarousel>
    </section>

    <section
      v-for="(c, ci) in categoryList"
      :key="ci"
      class="home-section"
      :class="{ 'home-section--full': !isProductMode(c) && (c.imgList?.length || 0) === 1 }"
    >
      <h2 class="home-section-title">{{ c.title || c.name }}</h2>
      <p class="home-section-sub">{{ c.description || c.desc }}</p>

      <div v-if="isProductMode(c)">
        <div v-if="(c.imgList?.length || 0) > 4" class="home-slider-container">
          <button class="slider-btn prev" @click="scrollSlider(ci, -1)">
            <i class="iconfont icon-fanhui"></i>
          </button>
          <div class="home-slider-track" :ref="(el) => setSliderRef(el, ci)">
            <div
              v-for="(it, i) in c.imgList"
              :key="i"
              class="home-slider-item"
              @click="handleCategoryItemClick(it, c)"
            >
              <ElImage :src="it.imgPath" class="img-ratio-slider" fit="cover" />
              <div class="home-card-content" v-if="c.style == 1">
                <h3 class="home-card-name">{{ it.prodName }}</h3>
                <div class="home-price-container" v-if="it.price">
                  <p class="home-member-price">会员价：￥{{ it.memberPrice || 0 }}</p>
                  <p class="home-original-price">￥{{ it.price }}</p>
                </div>
              </div>
            </div>
          </div>
          <button class="slider-btn next" @click="scrollSlider(ci, 1)">
            <i class="iconfont icon-jinru"></i>
          </button>
        </div>
        <div v-else class="home-grid-4">
          <div
            v-for="(it, i) in (c.imgList?.slice(0, 4) || [])"
            :key="i"
            class="home-card"
            @click="handleCategoryItemClick(it, c)"
          >
            <ElImage :src="it.imgPath" class="img-ratio-4" fit="cover" />
            <div class="home-card-content" v-if="c.style == 1">
              <h3 class="home-card-name">{{ it.prodName }}</h3>
              <p class="home-price" v-if="it.price">￥{{ it.price }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="(c.imgList?.length || 0) === 1" class="home-one-img" @click="handleCategoryItemClick(c.imgList[0], c)">
          <ElImage :src="c.imgList[0].imgPath" class="img-full" fit="cover" />
        </div>
        <div v-else-if="(c.imgList?.length || 0) === 2" class="home-grid-2">
          <div v-for="(it, i) in c.imgList" :key="i" class="home-card" @click="handleCategoryItemClick(it, c)">
            <ElImage :src="it.imgPath" class="img-ratio-2" fit="cover" />
            <div class="home-card-content" v-if="c.style == 1">
              <h3 class="home-card-name">{{ it.prodName }}</h3>
              <p class="home-price" v-if="it.price">￥{{ it.price }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="(c.imgList?.length || 0) === 3" class="home-grid-3">
          <div v-for="(it, i) in c.imgList" :key="i" class="home-card" @click="handleCategoryItemClick(it, c)">
            <ElImage :src="it.imgPath" class="img-ratio-3" fit="cover" />
            <div class="home-card-content" v-if="c.style == 1">
              <h3 class="home-card-name">{{ it.prodName }}</h3>
              <p class="home-price" v-if="it.price">￥{{ it.price }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="(c.imgList?.length || 0) === 4" class="home-grid-4">
          <div v-for="(it, i) in c.imgList" :key="i" class="home-card" @click="handleCategoryItemClick(it, c)">
            <ElImage :src="it.imgPath" class="img-ratio-4" fit="cover" />
            <div class="home-card-content" v-if="c.style == 1">
              <h3 class="home-card-name">{{ it.prodName }}</h3>
              <p class="home-price" v-if="it.price">￥{{ it.price }}</p>
            </div>
          </div>
        </div>
        <div v-else-if="(c.imgList?.length || 0) > 4" class="home-slider-container">
          <button class="slider-btn prev" @click="scrollSlider(ci, -1)">
            <i class="iconfont icon-fanhui"></i>
          </button>
          <div class="home-slider-track" :ref="(el) => setSliderRef(el, ci)">
            <div v-for="(it, i) in c.imgList" :key="i" class="home-slider-item" @click="handleCategoryItemClick(it, c)">
              <ElImage :src="it.imgPath" class="img-ratio-slider" fit="cover" />
              <div class="home-card-content" v-if="c.style == 1">
                <h3 class="home-card-name">{{ it.prodName }}</h3>
                <div class="home-price-container" v-if="it.price">
                  <p class="home-member-price">会员价：￥{{ it.memberPrice || 0 }}</p>
                  <p class="home-original-price">￥{{ it.price }}</p>
                </div>
              </div>
            </div>
          </div>
          <button class="slider-btn next" @click="scrollSlider(ci, 1)">
            <i class="iconfont icon-jinru"></i>
          </button>
        </div>
      </div>

      <div v-if="c.moreUrl" class="home-section-more">
        <a href="javascript:void(0)" class="home-more-btn" @click.prevent="handleMoreClick(c)">
          查看更多 <i class="iconfont icon-chakangengduo"></i>
        </a>
      </div>
    </section>

    <!-- 资讯板块 -->
    <section v-if="noticeList.length > 0" class="home-section">
      <h2 class="home-section-title">资讯</h2>
      <!-- <p class="home-section-sub">
        在瞬息万变的时代，洞见源于深度。我们为您凝练纷繁信息，萃取最具价值的行业洞察与趋势分析
      </p> -->

      <div :class="{
        'home-one-img': noticeList.length === 1,
        'home-grid-2': noticeList.length === 2,
        'home-grid-3': noticeList.length === 3
      }">
        <div v-for="(item, index) in noticeList" :key="index" class="home-card home-news-card" @click="handleNoticeClick(item)">
          <ElImage :src="item.pic" :class="noticeList.length === 1 ? 'img-full' : (noticeList.length === 2 ? 'img-ratio-2' : 'img-ratio-3')" fit="cover" />
          <div class="home-news-content">
            <h3 class="home-news-title">{{ item.title }}</h3>
            <div class="home-news-desc">{{ item.subTitle }}</div>
          </div>
        </div>
      </div>
      
      <div class="home-section-more">
        <a href="javascript:void(0)" class="home-more-btn" @click.prevent="router.push('/news')">
          查看更多 <i class="iconfont icon-chakangengduo"></i>
        </a>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { definePageMeta, useRouter, useHead } from "#imports";
import { ref, onMounted } from "vue";
import AppFooter from "@/components/AppFooter.vue";
definePageMeta({
  overlayHeader: true,
});
useHead({
  title:
    "yoostone品牌官方网站，独立珠宝设计师提供极简美学设计下的天然翡翠珠宝、翡翠定制珠宝。",
  meta: [
    {
      name: "description",
      content:
        "来自20年珠宝世家的独立珠宝设计师，为当代新知、独立女性提供极简美学设计下，高品质和极致价比的翡翠精工珠宝，翡翠定制珠宝。",
    },
    {
      name: "keywords",
      content:
        "yoostone, 天然翡翠，原石镶嵌，18K金翡翠，定制珠宝，翡翠珠宝，你我皆佩得。",
    },
  ],
});
const api = useApi();
const router = useRouter();
const bannerList = ref<any[]>([]);
const categoryList = ref<any[]>([]);
const noticeList = ref<any[]>([]);

// Layout helpers
const sliderRefs = ref<Record<number, HTMLElement>>({});
const sliderIndex = ref<Record<number, number>>({});
const setSliderRef = (el: any, index: number) => {
  if (el) sliderRefs.value[index] = el;
};
const scrollToIndex = (index: number, i: number) => {
  const el = sliderRefs.value[index];
  if (!el) return;
  const item = el.querySelector(".home-slider-item") as HTMLElement | null;
  const gap = parseFloat(getComputedStyle(el).gap || "0");
  const unit = (item?.clientWidth || el.clientWidth / 3.5) + gap;
  el.scrollTo({ left: Math.round(unit * i), behavior: "smooth" });
  sliderIndex.value[index] = i;
};
const scrollSlider = (index: number, dir: number) => {
  const el = sliderRefs.value[index];
  if (!el) return;
  const item = el.querySelector(".home-slider-item") as HTMLElement | null;
  const gap = parseFloat(getComputedStyle(el).gap || "0");
  const unit = (item?.clientWidth || el.clientWidth / 3.5) + gap;
  const perView = Math.max(1, Math.floor(el.clientWidth / Math.max(unit, 1)));
  const max = Math.max(0, Math.ceil((el.scrollWidth - el.clientWidth) / Math.max(unit, 1)));
  const cur = sliderIndex.value[index] || 0;
  const next = Math.max(0, Math.min(max, cur + dir * perView));
  scrollToIndex(index, next);
};

const isProductMode = (c: any) => {
  const list = c?.imgList || [];
  return list.length >= 4 || list.some((x: any) => x?.goodsId || x?.prodId || x?.productId);
};
const normalizeCategoryItem = (it: any) => {
  return {
    src: it?.imgUrl || it?.img || it?.url,
    goodsId: it?.goodsId || it?.prodId || it?.productId,
    link: it?.linkUrl || it?.url,
  };
};
const handleCategoryItemClick = (it: any, c?: any) => {
  const n = normalizeCategoryItem(it);
  let to = n.goodsId ? `/goods/${n.goodsId}` : n.link;
  
  if (c?.style === 2 && it?.imgUrl) {
    to = it.imgUrl;
  }

  if (!to) return;
  if (/^https?:\/\//.test(to)) {
    window.open(to, "_blank");
  } else {
    router.push(to);
  }
};

const fetchHomeData = async () => {
  try {
    const b = await api.get<any[]>("/indexImgs?clientType=1", undefined, { server: false, key: 'home-indexImgs', retry: 0 })
    if (b.ok) bannerList.value = Array.isArray(b.data) ? b.data : []
  } catch {}
  try {
    const c = await api.get<any>("/prod/tag/prodTagList?clientType=1", undefined, { server: false, key: 'home-prodTagList', retry: 0 })
    const list = Array.isArray(c.data?.records) ? c.data.records : Array.isArray(c.data) ? c.data : []
    if (c.ok) categoryList.value = list
  } catch {}
  try {
    const n = await api.get<any>("/shop/notice/noticeList", { type: 1 })
    const list = Array.isArray(n.data) ? n.data : (n.data?.records || n.data?.list || [])
    if (n.ok) noticeList.value = list.slice(0, 3)
  } catch {}
};
onMounted(fetchHomeData);

const handleNoticeClick = (item: any) => {
  if (item.id) {
    router.push(`/news/${item.id}`);
  } else {
    router.push('/news');
  }
};

const handleMoreClick = (c: any) => {
  const to = c?.moreUrl;
  if (!to) return;
  if (/^https?:\/\//.test(to)) {
    window.open(to, "_blank");
  } else {
    router.push(to);
  }
};

const handleHeroBuy = (b?: any) => {
  const id = b?.relation
  if (!id) return;
  router.push(`/goods/${id}`);
};

</script>

<style scoped>
.home-page {
  font-size: 0.16rem;
}

/* 顶部导航由布局提供 */

/* 头图 */
.home-hero {
  height: calc(100vh - 0.8rem);
}
.home-hero-slide {
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}
.home-hero-overlay {
  position: absolute;
  left: 0.9rem;
  bottom: 0.96rem;
  color: #fff;
}
.home-hero-title {
  font-size: 0.44rem;
  margin-bottom: 0.4rem;
  font-weight: 700;
}
.home-hero-desc {
  font-size: 0.24rem;
  margin-bottom: 0.44rem;
}
.home-btn-black {
  background: #121212;
  border-color: #121212;
  color: #fff;
  font-size: 0.2rem;
  width: 2.4rem;
  height: 0.64rem;
}

.home-hero :deep(.el-carousel__indicators) {
  bottom: 0.24rem;
}
.home-hero :deep(.el-carousel__indicator) {
  padding: 0;
}
.home-hero :deep(.el-carousel__indicator button) {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 100% !important;
  border: 0.02rem solid #fff;
  background: transparent;
  opacity: 1;
  margin: 0 0.04rem;
}
.home-hero :deep(.el-carousel__indicator.is-active button) {
  background: #fff;
  border-color: #fff;
}

.home-hero :deep(.el-carousel__arrow) {
  width: 0.6rem;
  height: 0.6rem;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border-radius: 50%;
}
.home-hero :deep(.el-carousel__arrow .el-icon) {
  font-size: 0.24rem;
}

/* 通用版块 */
.home-section {
  margin: 1.6rem auto;
  padding: 0 0.9rem;
}
.home-section--no-padding,
.home-section--full {
  padding: 0;
}

.home-one-img .img-full {
  width: 100%;
  height: auto;
  display: block;
}

.home-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.3rem;
}
.home-grid-2 .img-ratio-2 {
  width: 100%;
  aspect-ratio: 858 / 572;
}

.home-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.3rem;
}
.home-grid-3 .img-ratio-3 {
  width: 100%;
  aspect-ratio: 560 / 380;
}

.home-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.3rem;
}
.home-grid-4 .img-ratio-4 {
  width: 100%;
  aspect-ratio: 420 / 630;
}

/* Slider */
.home-slider-container {
  position: relative;
  display: flex;
  align-items: center;
}
.home-slider-track {
  display: flex;
  gap: var(--gap, 0.3rem);
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  width: 100%;
}
.home-slider-track::-webkit-scrollbar {
  display: none;
}
.home-slider-item {
  flex: 0 0 calc((100% - (var(--gap, 0.3rem) * 3)) / 3.5);
  cursor: pointer;
}
.home-slider-item .img-ratio-slider {
  width: 100%;
  aspect-ratio: 480 / 720;
}
.slider-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 0.6rem;
  height: 0.6rem;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: none;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  transition: all 0.3s;
}
.slider-btn:hover {
  background: rgba(0, 0, 0, 0.55);
}
.slider-btn.prev { left: 0.2rem; }
.slider-btn.next { right: 0.2rem; }

.home-section-title {
  font-size: 0.36rem;
  margin-bottom: 0.4rem;
  text-align: center;
  font-weight: 600;
  color: #333537;
}
.home-section-sub {
  font-size: 0.18rem;
  line-height: 0.3rem;
  text-align: center;
  color: #535557;
  margin-bottom: 1rem;
}

.home-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.3rem;
}
.home-cards--grid-4 {
  grid-template-columns: repeat(4, 1fr);
}
.home-cards--grid-3 {
  grid-template-columns: repeat(3, 1fr);
}
.home-card {
  overflow: hidden;
  background: #fff;
}
.home-card-image {
  width: 100%;
  height: 6.3rem;
}

.home-card-content {
  margin-top: 0.42rem;
  text-align: center;
}
.home-card-name {
  font-size: 0.14rem;
  color: #424446;
  margin-bottom: 0.1rem;
  padding: 0 0.2rem;
  line-height: 0.28rem;
}
.home-price-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
}
.home-member-price {
  font-size: 0.16rem;
  color: #FF4444;
  font-weight: 600;
  margin: 0;
}
.home-original-price {
  font-size: 0.14rem;
  color: #999;
  text-decoration: line-through;
  margin: 0;
}

/* 品牌故事 */
.home-story-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 0.6rem;
  align-items: center;
}
.home-story-image {
  width: 100%;
  height: 4rem;
  border-radius: 0.08rem;
}
.home-story-text h3 {
  font-size: 0.24rem;
  margin-bottom: 0.2rem;
}
.home-story-text p {
  font-size: 0.16rem;
  line-height: 1.7;
  margin-bottom: 0.2rem;
}
.home-icons {
  display: flex;
  gap: 0.2rem;
  font-size: 0.24rem;
}

/* 系列 */
.home-series-grid3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.4rem;
}
.home-series-item {
  text-align: center;
}
.home-series-image {
  width: 100%;
  height: 2.2rem;
  border-radius: 0.08rem;
}
.home-series-name {
  margin-top: 0.16rem;
}

/* 居中 Banner */
.home-banner {
  position: relative;
  height: 3rem;
  margin: 1rem 0;
}
.home-banner-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.85);
}
.home-banner-text {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
}
.home-banner-text h3 {
  font-size: 0.32rem;
  margin-bottom: 0.14rem;
  font-weight: 700;
}
.home-banner-text p {
  font-size: 0.16rem;
  margin-bottom: 0.22rem;
  opacity: 0.95;
}

/* 热卖缩略图 */
.home-thumbs {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 0.3rem;
}
.home-thumbs--five { grid-template-columns: repeat(5, 1fr); }
.home-thumbs--two { grid-template-columns: repeat(2, 1fr); }
.home-thumbs--two .home-thumb { height: 5.72rem; }
.home-thumbs.home-thumbs--one { grid-template-columns: repeat(1, 1fr); }
.home-thumbs--one .home-thumb { height: 6.4rem; }
.home-thumb {
  width: 100%;
  height: 5.72rem;
  overflow: hidden;
}

/* 大图展示 */
.home-feature {
  max-width: 12rem;
  margin: 1rem auto;
  padding: 0 0.4rem;
}
.home-feature-image {
  width: 100%;
  height: 4rem;
  border-radius: 0.08rem;
}

/* 页脚 */
.home-footer {
  background: #f7f7f7;
  padding: 0.8rem 0;
}
.home-footer-inner {
  max-width: 16rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.4rem;
  padding: 0 0.4rem;
}
.home-footer-title {
  font-weight: 600;
  margin-bottom: 0.18rem;
}

/* 订阅 */
.home-subscribe {
  text-align: center;
}
.home-subscribe-box {
  display: inline-flex;
  gap: 0.2rem;
  width: 6rem;
}

/* 响应优化 */
@media (max-width: 1024px) {
  .home-cards,
  .home-grid-3,
  .home-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .home-cards--grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .home-slider-item {
    flex: 0 0 calc((100% - (var(--gap, 0.3rem) * 2)) / 2.5);
  }
  .home-thumbs {
    grid-template-columns: repeat(3, 1fr);
  }
  .home-series-grid3 {
    grid-template-columns: repeat(2, 1fr);
  }
  .home-story-grid {
    grid-template-columns: 1fr;
  }
  .home-hero-overlay {
    padding-left: 0.6rem;
  }
}
@media (max-width: 640px) {
  .nav-inner {
    padding: 0 0.2rem;
  }
  .menu a {
    margin-left: 0.2rem;
  }
  .home-hero-title {
    font-size: 0.42rem;
  }
  .home-cards,
  .home-cards--grid-3,
  .home-cards--grid-4,
  .home-grid-2,
  .home-grid-3,
  .home-grid-4 {
    grid-template-columns: 1fr;
  }
  .home-slider-item {
    flex: 0 0 100%;
  }
  .home-thumbs,
  .home-thumbs--five {
    grid-template-columns: repeat(2, 1fr);
  }
}
.home-section-more {
  text-align: center;
  margin-top: 0.4rem;
}
.home-more-btn {
  display: inline-flex;
  align-items: center;
  font-size: 0.18rem;
  color: #333537;
  cursor: pointer;
  background: #fff;
}
.home-more-btn .iconfont {
  font-size: 0.24rem;
  margin-left: 0.04rem;
  color: #121212;
}
.home-more-btn:hover {
  border-color: #c0c4cc;
  color: #121212;
}

.home-news-card {
  cursor: pointer;
}
.home-news-content {
  margin-top: 0.2rem;
  text-align: left;
}
.home-news-title {
  font-size: 0.2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-news-desc {
  font-size: 0.14rem;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.home-news-desc * {
  font-size: inherit !important;
  color: inherit !important;
  line-height: inherit !important;
  margin: 0;
  padding: 0;
}
</style>
